import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { TelegramProvider } from '@/app/providers/TelegramProvider'
import { ErrorBoundary } from '@/app/components/ErrorBoundary'
import { TabLayout } from '@/app/components/TabLayout'
import { GeneratePage } from '@/pages/Generate'
import { HistoryPage } from '@/pages/History'
import { ResourcesPage } from '@/pages/Resources'
import { SearchPage } from '@/pages/Search'
import { TagsPage } from '@/pages/Tags'
import { SettingsPage } from '@/pages/Settings'
import { NotFoundPage } from '@/pages/NotFound'
import { Navigation } from '@/app/components/Navigation'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const TABS = [
  { path: '/', element: <GeneratePage /> },
  { path: '/history', element: <HistoryPage /> },
  { path: '/resources', element: <ResourcesPage /> },
  { path: '/search', element: <SearchPage /> },
  { path: '/tags', element: <TagsPage /> },
  { path: '/settings', element: <SettingsPage /> },
] as const

export function App() {
  return (
    <ErrorBoundary>
      <TelegramProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <TabLayout tabs={TABS} fallback={<NotFoundPage />} />
            <Navigation />
          </BrowserRouter>
        </QueryClientProvider>
      </TelegramProvider>
    </ErrorBoundary>
  )
}
